import { render, staticRenderFns } from "./UpdateCertificationForm.vue?vue&type=template&id=a211ac8a&"
import script from "./UpdateCertificationForm.vue?vue&type=script&lang=js&"
export * from "./UpdateCertificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports